module.exports = __webpack_public_path__ + "static/media/48389870_2309072909167887_6342806384177840128_o-thumb.69db5197.jpg";